import React from "react";

import { MarkButton } from "./buttons/markButton";
import { BlockButton } from "./buttons/blockButton";
import { ColorButton } from "./buttons/colorButton";
import { UploadImageButton } from "./buttons/uploadImageButton";
import { InsertEmbedButton } from "./buttons/embedButton";
import { LinkButton } from "./buttons/linkButton";
import { InsertTablePopoverButton } from "./buttons/insertTablePopoverButton";
import { UploadVideoButton } from "./buttons/uploadVideo";
import styles from "../editor.module.scss";
// import { HeadingSelector } from "./buttons/headings";
import { FontSizeSelector } from "./buttons/fontSize";
import { KIOButton } from "./buttons/kioai";

export const Toolbar = ({ editor, className, onUpdateAttachment, enabledButtons = null, fontSize, lookupId, commentId, workspaceId, folderId, disabled }) => {
  // Default all buttons to enabled if no `enabledButtons` is passed
  const defaultEnabledButtons = {
    undo: true,
    redo: true,
    fontSize: true,
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true,
    insertTable: true,
    uploadImageButton: true,
    uploadVideoButton: true,
    insertEmbed: true,
    aiDoc: false
  };

  // Merge the passed `enabledButtons` with the default ones
  const finalEnabledButtons = {};
  if (enabledButtons) {
    Object.assign(finalEnabledButtons, enabledButtons);
  } else {
    Object.assign(finalEnabledButtons, defaultEnabledButtons);
  }

  return (
    <div className={`${styles.toolbar} ${className}`}>
      {/* <HeadingSelector editor={editor} /> */}
      {/* {finalEnabledButtons.undo && <BlockButton editor={editor} icon="undo" />}
      {finalEnabledButtons.redo && <BlockButton editor={editor} icon="redo" />} */}
      {finalEnabledButtons.fontSize && <FontSizeSelector editor={editor} disabled={disabled} fontSize={fontSize} />}
      {finalEnabledButtons.bold && <MarkButton format="bold" icon="bold" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.italic && <MarkButton format="italic" icon="italic" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.underline && <MarkButton format="underline" icon="underline" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.strikethrough && <MarkButton format="strikethrough" icon="strikethrough" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.color && <ColorButton format="color" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.backgroundColor && <ColorButton format="backgroundColor" background editor={editor} disabled={disabled} />}
      {finalEnabledButtons.alignLeft && <BlockButton format="align-left" icon="align-left" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.alignCenter && <BlockButton format="align-center" icon="align-center" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.alignRight && <BlockButton format="align-right" icon="align-right" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.alignJustify && <BlockButton format="align-justify" icon="align-justify" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.blockquote && <BlockButton format="blockquote" icon="blockquote" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.numberedList && <BlockButton format="numbered-list" icon="ordered-list" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.unorderedList && <BlockButton format="unordered-list" icon="unordered-list" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.codeBlock && <BlockButton format="code-block" icon="code-block" editor={editor} disabled={disabled} />}
      {finalEnabledButtons.link && <LinkButton editor={editor} disabled={disabled} />}
      {finalEnabledButtons.insertTable && <InsertTablePopoverButton editor={editor} disabled={disabled} />}
      {finalEnabledButtons.uploadImageButton && <UploadImageButton folderId={folderId} editor={editor} disabled={disabled} commentId={commentId}
        onUpdateAttachment={onUpdateAttachment} workspaceId={workspaceId} lookupId={lookupId} />}
      {finalEnabledButtons.uploadVideoButton && <UploadVideoButton folderId={folderId} editor={editor} disabled={disabled} commentId={commentId}
        onUpdateAttachment={onUpdateAttachment} workspaceId={workspaceId} lookupId={lookupId} />}
      {finalEnabledButtons.insertEmbed && <InsertEmbedButton editor={editor} disabled={disabled} />}
      {finalEnabledButtons.aiDoc && <KIOButton editor={editor} disabled={disabled} />}
    </div>
  );
};
